// project import
import AuthWrapper from 'sections/auth/AuthWrapper';
import AuthSetPassword from 'sections/auth/auth-forms/AuthSetPassword';

// ================================|| SET PASSWORD (after the registration) ||================================ //

const SetPassword = () => (
    <AuthWrapper>
        <div className="flex flex-col gap-6">
            <div className="-mb-1 flex flex-col gap-2 sm:mb-1">
                <h3 className="text-h3 text-balance">New Password Required</h3>
                <p className="text-body1 text-fg-secondary">
                    Please enter your temporary password that was sent to your email and choose a new one
                </p>
            </div>
            <AuthSetPassword />
        </div>
    </AuthWrapper>
);

export default SetPassword;
